import React from 'react';

import Header from '../../components/header';
import Footer from '../../components/footer';
import Cards from '../../components/cards';
import imgRenew from '../../assets/renew.svg';
import imgInstall from '../../assets/install.svg';
import './styles.css';

export default function Options() {
  return (
    <>
      <Header content="Escolha uma das opções abaixo" />
      <div className="options-container">
        <Cards
          imgCard1={imgRenew}
          spanCard1="Renovação Online"
          linkCard1="/renew"
          imgCard2={imgInstall}
          spanCard2="Instalação Certificado"
          linkCard2="/certificates"
        />
      </div>
      <Footer />
    </>
  );
}
